export type TermStatus = 'active' | 'renewing-soon' | 'ended';

// Purely a presentational threshold over real startTime/endTime values —
// not a backend-defined status. Kept short and named for what it does
// rather than treated as a lifecycle the backend enforces.
const RENEWAL_WINDOW_DAYS = 60;

export function subscriptionTermStatus(
  endTime: string | undefined,
  now: Date = new Date(),
): TermStatus {
  if (!endTime) return 'active';
  const end = new Date(endTime);
  if (Number.isNaN(end.getTime())) return 'active';
  const daysRemaining = (end.getTime() - now.getTime()) / (1000 * 60 * 60 * 24);
  if (daysRemaining < 0) return 'ended';
  if (daysRemaining <= RENEWAL_WINDOW_DAYS) return 'renewing-soon';
  return 'active';
}

/** Fraction of the term elapsed, clamped to [0, 1]; 0 when dates are missing or invalid. */
export function termProgress(
  startTime: string | undefined,
  endTime: string | undefined,
  now: Date = new Date(),
): number {
  if (!startTime || !endTime) return 0;
  const start = new Date(startTime).getTime();
  const end = new Date(endTime).getTime();
  if (Number.isNaN(start) || Number.isNaN(end) || end <= start) return 0;
  return Math.min(1, Math.max(0, (now.getTime() - start) / (end - start)));
}
